<script setup>
import { Link } from '@inertiajs/vue3'
import moment from 'moment'
import { Popover, PopoverContent, PopoverTrigger } from '@codinglabsau/gooey'
import { MessageCircleMoreIcon } from 'lucide-vue-next'
import UserAvatar from './UserAvatar.vue'
import MessageUserModal from '../Conversations/MessageUserModal.vue'

defineProps({
  user: Object,
})
</script>

<template>
  <Popover>
    <PopoverTrigger>
      <span class="hover:underline">{{ user.name }} </span>
    </PopoverTrigger>
    <PopoverContent class="space-y-3 text-sm">
      <div class="flex justify-between">
        <UserAvatar :user="user" small class="mr-2" />
        <MessageUserModal
          v-if="$page.props.auth.user?.id !== user.id"
          :recipient="user"
          variant="outline"
        >
          <MessageCircleMoreIcon class="size-4" />
        </MessageUserModal>
      </div>

      <Link
        :href="route('members.show', user.id)"
        class="flex justify-between gap-2 hover:underline"
        rel="nofollow"
      >
        <div>
          <div class="font-medium">{{ user.name }}</div>
        </div>
      </Link>
      <div class="text-sm text-gray-500">Rank: {{ user.rank }} ({{ user.reputation }})</div>
      <div>
        <span class="text-gray-500">Member since </span>
        {{ moment(user.created_at).format('Do MMMM YYYY') }}
      </div>
      <div>
        <span class="text-gray-500"> </span>
      </div>
    </PopoverContent>
  </Popover>
</template>
